import { GIA_CORE_KNOWLEDGE, GIA_FLOW_KNOWLEDGE, GIA_MODULE_KNOWLEDGE, GIA_SUBSECTION_KNOWLEDGE } from './knowledge';

const DEFAULT_VIEW = 'menu';

export const normalizeGiaView = (view = '') => {
  const normalized = String(view || '').trim();
  if (!normalized) return DEFAULT_VIEW;
  if (normalized === 'fleetExpenses') return 'fleetExpenses';
  if (normalized === 'systemGuide') return 'systemGuide';
  return GIA_MODULE_KNOWLEDGE[normalized] ? normalized : DEFAULT_VIEW;
};

export const getGiaModuleKnowledge = (view, options = {}) => {
  const normalized = options.isArchitectView ? 'architect' : normalizeGiaView(view);
  const moduleKnowledge = GIA_MODULE_KNOWLEDGE[normalized] || GIA_MODULE_KNOWLEDGE[DEFAULT_VIEW];

  if (normalized === 'logistics' && options.selectedTransport?.name) {
    return {
      ...moduleKnowledge,
      sectionLabel: moduleKnowledge.sectionLabel,
      summary: `${moduleKnowledge.summary} Unidad en foco: ${options.selectedTransport.name}.`,
    };
  }

  return moduleKnowledge;
};

export const getGiaSubsectionKnowledge = (view, subsectionLabel = '', options = {}) => {
  const normalized = options.isArchitectView ? 'architect' : normalizeGiaView(view);
  const label = String(subsectionLabel || '').trim();
  if (!label) return null;
  return GIA_SUBSECTION_KNOWLEDGE?.[normalized]?.[label] || null;
};

export const getGiaFlowKnowledge = (flowKey = '') => GIA_FLOW_KNOWLEDGE[flowKey] || null;

export const buildGiaContextPacket = ({
  view,
  companyName = '',
  selectedTransport = null,
  isArchitectView = false,
  subsectionLabel = '',
  focusLabel = '',
} = {}) => {
  const moduleKnowledge = getGiaModuleKnowledge(view, { selectedTransport, isArchitectView });
  const subsectionKnowledge = getGiaSubsectionKnowledge(view, subsectionLabel, { isArchitectView });
  const sectionLabel = subsectionLabel || moduleKnowledge.sectionLabel || moduleKnowledge.label || 'Inicio';

  const effectiveSummary = subsectionKnowledge?.summary || moduleKnowledge.summary;
  const contextParts = [];
  if (!isArchitectView && companyName) contextParts.push(companyName);
  if (subsectionLabel && subsectionLabel !== moduleKnowledge.sectionLabel) contextParts.push(subsectionLabel);
  if (focusLabel) contextParts.push(focusLabel);

  const contextLead = contextParts.join(' · ');
  const contextLabel = contextLead ? `${contextLead}. ${effectiveSummary}` : effectiveSummary;

  return {
    sectionLabel,
    moduleLabel: moduleKnowledge.label || sectionLabel,
    contextLabel,
    module: moduleKnowledge,
    supportModel: GIA_CORE_KNOWLEDGE.identity.supportModel,
    subsectionLabel,
    focusLabel,
  };
};

export const buildGiaQuickAnswers = (view, options = {}) => {
  const moduleKnowledge = getGiaModuleKnowledge(view, options);
  const subsectionKnowledge = getGiaSubsectionKnowledge(view, options.subsectionLabel, options);
  const knowledge = subsectionKnowledge ? { ...moduleKnowledge, ...subsectionKnowledge } : moduleKnowledge;
  return {
    summary: knowledge.summary,
    purpose: knowledge.purpose,
    canDo: knowledge.canDo || [],
    commonIssues: knowledge.commonIssues || [],
    nextStepHint: knowledge.nextStepHint || '',
  };
};

const giaKnowledgeApi = {
  normalizeGiaView,
  getGiaModuleKnowledge,
  getGiaSubsectionKnowledge,
  getGiaFlowKnowledge,
  buildGiaContextPacket,
  buildGiaQuickAnswers,
};

export default giaKnowledgeApi;
